export default function ErrorMessage(props: { error: string | null }) {
  if (props.error === null) {
    return null;
  }
  return (
    <div className="errorPopup">
        {props.error}
    </div>
  );
}